import { render, staticRenderFns } from "./Fang.vue?vue&type=template&id=f36315ec&"
import script from "./Fang.vue?vue&type=script&lang=js&"
export * from "./Fang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports